import { Link } from "gatsby"
import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { SiteTitleQueryQuery } from "../generated/graphql-types"

export default () => {
  const data = useStaticQuery<SiteTitleQueryQuery>(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const siteTitle = data?.site?.siteMetadata?.title || "Yondemy";

  return (
    <header>
      <h1>
        <Link to="/">
          {siteTitle}
        </Link>
      </h1>
    </header>
  );
}
